import * as Factory from 'factory.ts'
import faker from 'faker'

import { AccountCodeMock } from './accountcode.factory'
import { CurrencyMock } from './currency.factory'
import {
  CustomFieldFormValueMock,
  CustomFieldValueMock,
} from './customfield.factory'
import { VendorMock } from './vendor.factory'
import {
  type CatalogBundle,
  type CatalogBundleItem,
  type CatalogItem,
  type CatalogItemFormSchema,
} from '../../models'

export const CatalogItemMock = Factory.Sync.makeFactory<CatalogItem>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.commerce.productName()),
  currency: CurrencyMock.build({ name: 'CAD' }),
  price: Factory.each(() => parseFloat(faker.commerce.price())),
  custom_fields: CustomFieldValueMock.buildList(4),
  account_code: AccountCodeMock.build(),
  description: Factory.each(() => faker.lorem.sentence()),
  pref_vendor: Factory.each(() => VendorMock.build()),
  rfo_lock: false,
  departments: [],
  selected_account: null,
  requested_count: faker.random.number(),
  last_requested_date: faker.date.past(10).toISOString(),
  image: `/attachments/${faker.random.uuid()}`,
  unitType: Factory.each(() => faker.commerce.productAdjective()),
  internalSKU: Factory.each(() => faker.random.alphaNumeric(5)),
})

export const CatalogItemFormMock =
  Factory.Sync.makeFactory<CatalogItemFormSchema>({
    id: Factory.each(() => faker.random.number()),
    name: faker.commerce.productName(),
    currency: CurrencyMock.build({ name: 'CAD' }),
    price: parseFloat(faker.commerce.price()),
    custom_fields: CustomFieldFormValueMock.buildList(4),
    account_code: AccountCodeMock.build(),
    description: faker.lorem.sentence(),
    pref_vendor: VendorMock.build(),
    rfo_lock: false,
    departments: [],
    selected_account: null,
    requested_count: faker.random.number(),
    last_requested_date: faker.date.past(10).toISOString(),
    image: null,
    unitType: null,
  })

export const CatalogBundleItemMock =
  Factory.Sync.makeFactory<CatalogBundleItem>({
    id: Factory.each(() => faker.random.number()),
    name: faker.commerce.productName(),
    currency: CurrencyMock.build({ name: 'CAD' }),
    price: parseFloat(faker.commerce.price()),
    custom_fields: CustomFieldValueMock.buildList(4),
    account_code: AccountCodeMock.build(),
    description: faker.lorem.sentence(),
    pref_vendor: VendorMock.build(),
    rfo_lock: false,
    departments: [],
    selected_account: null,
    requested_count: faker.random.number(),
    last_requested_date: faker.date.past(10).toISOString(),
    image: `/attachments/${faker.random.uuid()}`,
    unitType: faker.commerce.productAdjective(),
    quantity: faker.random.number(),
  })

export const CatalogBundleMock = Factory.Sync.makeFactory<CatalogBundle>({
  id: Factory.each(() => faker.random.number()),
  active: true,
  items: Factory.each(() => CatalogBundleItemMock.buildList(1)),
  name: Factory.each(() => faker.commerce.product()),
  description: Factory.each(() => faker.lorem.sentence()),
  image: `/attachments/${faker.random.uuid()}`,
})
